import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { resetMarketAreaDrawing } from "../resetMarketAreaDrawing";
import { TDrawMode } from "../types";

type TMarketAreaModeState = {
  drawMode: TDrawMode | null;
  isCreating: boolean;
  editingAreaId: string | null;
  selectedAreaId: string | null;
  isSuccessOpen: boolean;
};

const initialState: TMarketAreaModeState = {
  drawMode: null,
  isCreating: false,
  editingAreaId: null,
  selectedAreaId: null,
  isSuccessOpen: false,
};

const marketAreaModeSlice = createSlice({
  name: "marketAreaMode",
  initialState,
  reducers: {
    setDrawMode: (state, { payload }: PayloadAction<TDrawMode | null>) => {
      state.drawMode = payload;
    },
    setIsCreating: (state, { payload }: PayloadAction<boolean>) => {
      state.isCreating = payload;
    },
    setEditingAreaId: (state, { payload }: PayloadAction<string | null>) => {
      state.editingAreaId = payload;
    },
    setSelectedAreaId: (state, { payload }: PayloadAction<string | null>) => {
      state.selectedAreaId = payload;
    },
    setIsSuccessOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.isSuccessOpen = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetMarketAreaDrawing, (state) => {
      state.drawMode = initialState.drawMode;
      state.isCreating = initialState.isCreating;
      state.editingAreaId = initialState.editingAreaId;
    });
  },
});

export const {
  setDrawMode,
  setIsCreating,
  setEditingAreaId,
  setSelectedAreaId,
  setIsSuccessOpen,
} = marketAreaModeSlice.actions;

export default marketAreaModeSlice;
